<template>
    <section>
        <div class="row">
            <div class="col-sm-9">
                <h5 class="mr-sm-2 ">
                    <b>Two-Step Authentication</b><br/>
                    Keep your account extra secure with a second authentication step.
                </h5>
            </div>
            <div class="col-sm-3 ">
                <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate pull-left " v-on:click="updateTwoFA()" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : twoFAFlag, 'bootstrap-switch-off bootstrap-switch-focused' : !twoFAFlag }">
                    <div class="bootstrap-switch-container" >
                        <span class="bootstrap-switch-handle-on bootstrap-switch-primary"><i class="fa fa-check" slot="on"></i></span>
                        <span class="bootstrap-switch-label"></span>
                        <span class="bootstrap-switch-handle-off bootstrap-switch-default"><i class="fa fa-times" slot="off"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div class="row" v-if="twoFAMethods">
            <div class="col-md-6">
                <h5>Current Authentication Method</h5>
                <div style="display: flex">
                    <div style="flex-grow: 0.5"><b>{{twoFAMethods}}</b></div>
                    <div><a href="javascript:void(0)" @click="openChangeAuthModal()">Change Authentication Step</a></div>
                </div>
            </div>
        </div>

        <div class="stepModal position-relative">
            <div class="modal fade" id="twoFAStepModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="twoFAStepModalHeader">Select Authentication Step</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <section v-if="stepSection === 'firstStep'">
                                <div class="row" v-for="(method,index) in methods" :key="index">
                                    <label class="col-6 col-form-label" ><b>{{method}}</b></label>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <div class="custom-control custom-radio d-flex  mt-2">
                                                <input type="radio" class="custom-control-input " name="faMethod" :value="method" v-model="newMethod" :id="'two_fa_'+index"/>
                                                <label class="custom-control-label " :for="'two_fa_'+index"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-sm pull-right" @click="changeStep('')">Next</button>
                                    </div>
                                </div>
                            </section>
                            <section v-if="stepSection === 'app-1'">
                               <div class="row">
                                   <div class="col-md-12 text-center">
                                       <p>Download the free <span class="text-info"><a target="_blank" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en">Google Authenticator</a></span> app, click add, and scan this barcode to set up your account.</p>
                                       <div class="card"  v-if="loading">
                                           <!-- Show the loader when async operation is going on -->
                                           <div class="loader"></div>
                                       </div>
                                       <qrcode v-if="!loading" :value="token" :options="{ width: 200 }"></qrcode>
                                       <p class="text-primary">Enter the below code manually instead</p>
                                       <b>{{ascii_code}}</b>
                                   </div>
                               </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-sm pull-left" @click="changeStep('firstStep')">Prev</button>
                                        <button class="btn btn-primary btn-sm pull-right" @click="changeStep('app-2')">Next</button>
                                    </div>
                                </div>
                            </section>
                            <section v-if="stepSection === 'app-2'">
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                       <div class="form-group">
                                           <label>Enter the verification code generated by your authenticator app</label>
                                           <input type="text" class="form-control" v-model="authAppCode" placeholder="Enter OTP Here..." />
                                       </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-sm pull-left" @click="changeStep('app-1')">Prev</button>
                                        <button class="btn btn-primary btn-sm pull-right" :disabled="loading" @click="finish2FA()">
                                            <div class="loader small_loader" v-if="loading"></div>
                                            <span v-else>Finish</span>
                                        </button>
                                    </div>
                                </div>
                            </section>
                            <section v-if="stepSection === 'email-1'">
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <div class="form-group">
                                            <label>A code has been sent to your email on file. Please provide the code below to complete your Two Factor Authentication setup via email.</label>
                                            <input type="text" class="form-control" v-model="authEmailCode" placeholder="Enter OTP Here..." />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-sm pull-left" @click="changeStep('firstStep')">Prev</button>
                                        <button class="btn btn-primary btn-sm pull-right" :disabled="loading" @click="finish2FA()">
                                            <div class="loader small_loader" v-if="loading"></div>
                                            <span v-else>Finish</span>
                                        </button>
                                    </div>
                                </div>
                            </section>

                            <section v-if="stepSection === 'sms-1'">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p>Provide us country code with your mobile phone number, we'll send you an SMS when you try to login.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="mobile-number">
                                                Mobile Number
                                            </label>
                                            <input type="text" class="form-control" id="mobile-number" placeholder="+1 (555) 678-1212" required v-model.trim="mobile_number">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-sm pull-left" @click="changeStep('firstStep')">Prev</button>
                                        <button class="btn btn-primary btn-sm pull-right" :disabled="mobile_number===null || loading" @click="addMobileNumber()">
                                            <div class="loader small_loader" v-if="loading"></div>
                                            <span v-else>Next</span>
                                        </button>
                                    </div>
                                </div>
                            </section>
                            <section v-if="stepSection === 'sms-2'">
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <div class="form-group">
                                            <label>A code has been sent to your mobile number. Please provide the code below to complete your Two Factor Authentication setup via sms.</label>
                                            <input type="text" class="form-control" v-model="authSmsCode" placeholder="Enter OTP Here..." />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-sm pull-left" @click="changeStep('firstStep')">Prev</button>
                                        <button class="btn btn-primary btn-sm pull-right" :disabled="loading" @click="finish2FA()">
                                            <div class="loader small_loader" v-if="loading"></div>
                                            <span v-else>Finish</span>
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { db, auth } from "@/firebase/init";
    import swal from 'sweetalert2';
    import Vue from 'vue';
    import VueQrcode from '@chenfengyuan/vue-qrcode';

    Vue.component(VueQrcode.name, VueQrcode);

    export default {
        name: "TwoFAUpdate",
        data(){
          return{
              loading:false,
              twoFAFlag:false,
              mobile_number:null,
              clicked_index:null,
              stepSection: 'firstStep',
              token:null,
              ascii_code: '',
              authAppCode: '',
              authEmailCode: '',
              authSmsCode: '',
              methods: [
                'Email', 'Authenticator App' , 'SMS'
              ],
              twoFAMethods: '',
              newMethod: '',
          }
        },
        computed:{
            userUId() {
                return this.$store.getters.getUID;
            },
        },
        async created(){
            console.log(this.userUId);
            const doc = await db.collection("users").doc(this.userUId).get();
            this.twoFAFlag = doc.data().twoFA;
            this.twoFAMethods = doc.data().twoFAMethods;
            if(this.twoFAFlag){
                this.methods.splice(this.methods.indexOf(this.twoFAMethods),1);
            } else if (this.$route.fullPath.includes('admin')) {
              this.$emit('toggleBanner')
            }
        },
        mounted() {
            $('#twoFAStepModal').on('hidden.bs.modal', async () => {
                this.init2FA();
            })
        },
        methods:{
            openChangeAuthModal() {
                this.init2FA();
                $('#twoFAStepModal').modal('show');
                $('.modal-backdrop').removeClass("modal-backdrop");
            },
            async init2FA() {
                const doc = await db.collection("users").doc(this.userUId).get();
                this.twoFAFlag = doc.data().twoFA;
                this.twoFAMethods = doc.data().twoFAMethods;
                this.stepSection = 'firstStep';
            },
            async updateTwoFA(){
                if(!this.twoFAFlag){
                    $('#twoFAStepModal').modal('show');
                    $('.modal-backdrop').removeClass("modal-backdrop");
                    this.twoFAFlag = true;
                    this.stepSection = 'firstStep';
                }else{
                    swal({
                        title: "Are you sure?",
                        text: `Are you sure to disable two factor authentication.`,
                        type: "question",
                        confirmButtonText: "Yes Proceed",
                        confirmButtonColor: "#6ACF98",
                        showCancelButton: true,
                        cancelButtonText: "No Thanks",
                        cancelButtonColor: "#EE8057"
                    })
                        .then(async result => {
                            if(result.value){
                                await db.collection("users").doc(this.userUId).update({
                                    twoFAMethods: '',
                                    twoFA: false,
                                    twoFASecret: '',
                                    twoFAVerified: false

                                });
                                this.methods= [
                                    'Email', 'Authenticator App' , 'SMS'
                                ];
                                if (this.$route.fullPath.includes('admin')){
                                  this.$emit('toggleBanner')
                                }
                                this.init2FA();
                                const userDtls = JSON.parse(localStorage.getItem("userDtls"));
                                userDtls.twoFA = false
                                localStorage.setItem("userDtls", JSON.stringify(userDtls))
                            }
                        });
                }
            },
            async addMobileNumber(){
                this.loading = true;
                await db.collection("users").doc(this.userUId).update({
                    mobile_number:this.mobile_number,
                });
                this.$http.post('/2FO/generate_secret',{
                    grant_type: 'token',
                    UID: this.userUId,
                    method: 'SMS'
                }).then(()=>{
                    this.loading = false;
                    this.stepSection = 'sms-2';
                }).catch(()=>{
                    this.loading = false;
                    swal('Error!', 'SMS not sent!', 'error');
                });
            },
            async finish2FA(){
                switch (this.newMethod) {
                    case 'Authenticator App':
                    {
                        this.loading = true;
                        this.$http.post('/2FO/verify_token', {
                            grant_type: 'token',
                            twoFAToken: this.authAppCode,
                            UID: this.userUId,
                            isConfirmation : '1',
                        }).then(async () => {
                            await db.collection("users").doc(this.userUId).update({
                                twoFAMethods: this.newMethod,
                                twoFA: this.twoFAFlag,
                                twoFAVerified: true
                            });
                            this.twoFAMethods = this.newMethod;
                            this.methods =  [
                                'Email', 'SMS'
                            ];
                            this.loading = false;
                            $("#twoFAStepModal").modal('hide');
                            if (this.$route.fullPath.includes('admin')){
                              this.$emit('toggleBanner')
                            }
                            swal('Success', 'Authentication has been successfully Completed!', 'success');
                        }).catch(() => {
                            this.loading = false;
                            swal('Error!', 'Invalid Token', 'error');
                        })
                    }
                        break;
                    case 'Email':
                        {
                            this.loading = true;
                            this.$http.post('/2FO/verify_token', {
                                grant_type: 'token',
                                twoFAToken: this.authEmailCode,
                                UID: this.userUId,
                                isConfirmation : '1',
                            }).then(async () => {
                                await db.collection("users").doc(this.userUId).update({
                                    twoFAMethods: this.newMethod,
                                    twoFA: this.twoFAFlag,
                                    twoFAVerified: true
                                });
                                this.twoFAMethods = this.newMethod;
                                this.authEmailCode = '';
                                this.methods =  [
                                    'Authenticator App' , 'SMS'
                                ];
                                this.loading = false;
                                $("#twoFAStepModal").modal('hide');
                                swal('Success', 'Authentication has been successfully Completed!', 'success');
                            }).catch(() => {
                                this.loading = false;
                                swal('Error!', 'Invalid Token', 'error');
                            })
                        }
                        break;
                    case 'SMS':
                        this.loading = true;
                        this.$http.post('/2FO/verify_token', {
                            grant_type: 'token',
                            twoFAToken: this.authSmsCode,
                            UID: this.userUId,
                            isConfirmation : '1',
                        }).then(async () => {
                            await db.collection("users").doc(this.userUId).update({
                                twoFAMethods: this.newMethod,
                                twoFA: this.twoFAFlag,
                                twoFAVerified: true
                            });
                            this.authSmsCode = '';
                            this.twoFAMethods = this.newMethod;
                            this.methods =  [
                                'Email', 'Authenticator App'
                            ];
                            this.loading = false;
                            $("#twoFAStepModal").modal('hide');
                            swal('Success', 'Authentication has been successfully Completed!', 'success');
                        }).catch(() => {
                            this.loading = false;
                            swal('Error!', 'Invalid Token', 'error');
                        });
                        break;
                    default:
                        swal('Invalid Selection', 'Please select authentication method', 'error');
                }
            },
            async changeStep(section){
              if(this.stepSection === 'firstStep'){
                  switch (this.newMethod) {
                      case 'Authenticator App':
                          {
                              this.stepSection = 'app-1';
                              this.loading = true;
                              let res = await this.$http.post('/2FO/otp_auth',{
                                  grant_type: 'token',
                                  UID: this.userUId
                              });
                              this.loading = false;
                              this.token = res.data.otp_auth;
                              this.ascii_code = res.data.ascii;
                          }
                          break;
                      case 'Email':
                          {
                              this.stepSection = 'email-1';
                              await this.$http.post('/2FO/generate_secret',{
                                  grant_type: 'token',
                                  UID: this.userUId,
                                  method: 'Email'
                              });
                          }
                          break;
                      case 'SMS':
                          this.stepSection = 'sms-1';
                          break;
                      default:
                          swal('Invalid Selection', 'Please select authentication method', 'error');
                  }
              }else{
                  this.stepSection = section;
              }
            }
        }
    }
</script>

<style scoped>
.hide{
    display: none !important;
}
.modal.show{
  height: 85vh;
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.modal-dialog{
  width: 500px !important;
}
</style>
